document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector("form[data-type='add-to-cart-form']");
  if (!form) return;

  let redirectPending = false;

  form.addEventListener("submit", function () {
    redirectPending = true;
  }, true);

  // Watch for Shopify cart changes via URL state + fetch completion fallback
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    return originalFetch.apply(this, args).then(response => {

      if (!redirectPending) return response;

      const url = args?.[0];

      if (typeof url === "string" && url.includes("/cart/add")) {
        redirectPending = false;

        // small delay ensures Shopify finishes internal state updates
        setTimeout(() => {
          window.location.href = "/cart";
        }, 150);
      }

      return response;
    });

  };

});